import {adminGuard} from '../guards';
import Profile from '../../pages/user/Profile';
import ShowProfile from '../../pages/user/ShowProfile';
import ChangePassword from '../../pages/user/ChangePassword';
import EditProfile from '../../pages/user/EditProfile';
import SetupTfa from '../../pages/user/SetupTfa';
import NylasError from '../../pages/nylas/Error';
import Contacts from '../../pages/nylas/Contacts';
import ContactCard from '../../pages/nylas/components/ContactCard';
import Folders from '../../pages/folders/Folders';
import Presentations from '../../pages/presentations/Presentations';
import UploadPresentations from '../../pages/presentations/UploadPresentations';
import Presentation from '../../pages/presentations/Presentation';
import ShowPresentation from '../../pages/presentations/ShowPresentation';
import PresentationInfo from '../../pages/presentations/PresentationInfo';
import EditPresentation from '../../pages/presentations/EditPresentation';
import UploadPresentation from '../../pages/presentations/UploadPresentation';
import TeamDashboard from '../../pages/dashboards/TeamDashboard';
import User from '../../pages/users/User';
import ShowUser from '../../pages/users/ShowUser';
import UserConnections from '../../pages/users/UserConnections';
import EditUser from '../../pages/users/EditUser';
import UserTeams from '../../pages/users/UserTeams';
import BlockedRecipients from '../../pages/blocked-recipients/BlockedRecipients';
import Groups from '../../pages/groups/Groups';
import Group from '../../pages/groups/Group';
import EditGroup from '../../pages/groups/EditGroup';
import ShowGroup from '../../pages/groups/ShowGroup';
import CreateGroup from '../../pages/groups/CreateGroup';
import GroupMembershipGrid from '../../pages/groups/GroupMembershipGrid.vue';
import PresentationGrid from '../../pages/groups/PresentationGrid.vue';
import ShareTemplateGrid from '../../pages/groups/ShareTemplateGrid.vue';
import Subscription from '../../pages/billing/Subscription';
import ChangeSubscriptionReview from '../../pages/billing/ChangeSubscriptionReview';
import EditBillingDetails from '../../pages/billing/EditBillingDetails';
import EditTeam from '../../pages/teams/EditTeam';
import Users from '../../pages/users/Users';
import CreateUser from '../../pages/users/CreateUser';
import MailcoachAdminRoutes from './mailcoachAdmin';
import MailgunAdminRoutes from './mailgunAdmin';
import LabelAdminRoutes from './labelAdmin';
import ShareTemplatesAdminRoutes from './shareTemplatesAdmin';
import TeamDomainAdminRoutes from './teamDomainsAdmin';
import VaultRoutes from './vault';
import PepperFlowRoutes from './pepperFlow'; // MLD-5650
import AdminUserContacts from '../../pages/user-contacts/AdminUserContacts';
import AdminUploadUserContacts from '../../pages/user-contacts/AdminUploadUserContacts';
import AdminSharingSessions from '../../pages/insights/AdminSharingSessions'; // MLD-3875
import AdminShowSharingSession from '../../pages/insights/AdminShowSharingSession'; // MLD-3875
// MLD-3306
import Products from '../../pages/products/Products';
// MLD-4360
import CreateProduct from '../../pages/products/CreateProduct.vue';
import EditProduct from '../../pages/products/EditProduct.vue';
import ShowProduct from '../../pages/products/ShowProduct.vue';

// MLD-4796
import Brands from '../../pages/brands/Brands.vue';
import CreateBrand from '../../pages/brands/CreateBrand.vue';
import EditBrand from '../../pages/brands/EditBrand.vue';
import ShowBrand from '../../pages/brands/ShowBrand.vue';

// MLD-4908
// MLD-5472
import Territories from '../../pages/territories/Territories.vue';
import Territory from '../../pages/territories/Territory.vue';
import EditTerritory from '../../pages/territories/EditTerritory.vue';
import ShowTerritory from '../../pages/territories/ShowTerritory.vue';
import AdministratorPermissionGrid from '../../pages/users/AdministratorPermissionGrid.vue';

// MLD-5628
import AdminTeamAssets from '../../pages/team_assets/AdminTeamAssets.vue';

// MLD-5627
import AdminSharedLinks from '../../pages/shared_links/AdminSharedLinks.vue';
import SharedLink from '../../pages/shared_links/SharedLink.vue';
import EditSharedLink from '../../pages/shared_links/EditSharedLink.vue';

// MLD-5635
// MLD-5970
import DisclaimerAdminRoutes from './disclaimerAdmin';

// MLD-6435
import AdminSlides from '../../pages/slide_builder/AdminSlides.vue';
import AdminSlideDecks from '../../pages/slide_builder/AdminSlideDecks.vue';
import AdminTeams from '../../pages/teams/AdminTeams.vue';

// MLD-6326
import Subscribers from '../../pages/subscribers/Subscribers.vue';

export default [
  ...adminGuard([
    {
      path: '/v2/admin/account',
      component: Profile,
      children: [
        {
          path: '',
          name: 'show_profile',
          component: ShowProfile,
        },
        {
          path: 'change-password',
          name: 'change_password',
          component: ChangePassword,
        },
        {
          path: 'edit',
          name: 'edit_profile',
          component: EditProfile,
        },
        {
          path: 'setup-tfa',
          name: 'setup_tfa',
          component: SetupTfa,
        },
      ]
    },
    { // MLD-4796
      path: '/v2/admin/brands',
      name: 'admin.brands.index',
      component: Brands,
      meta: {
        permission: 'can_edit_brands',
      },
    },
    { // MLD-4796
      path: '/v2/admin/brands/create',
      name: 'admin.brand.create',
      component: CreateBrand,
      meta: {
        permission: 'can_edit_brands',
      },
    },
    { // MLD-4796
      path: '/v2/admin/brands/:brandID(\\d+)',
      name: 'admin.brand.show',
      component: ShowBrand,
      meta: {
        permission: 'can_edit_brands',
      },
    },
    { // MLD-4796
      path: '/v2/admin/brands/:brandID(\\d+)/edit',
      name: 'admin.brand.edit',
      component: EditBrand,
      meta: {
        permission: 'can_edit_brands',
      },
    },
    { // MLD-2221
      path: '/v2/admin/email/error',
      name: 'admin.nylas.email_error',
      component: NylasError,
    },
    { // MLD-2221
      path: '/v2/admin/contacts',
      name: 'admin.nylas.contacts',
      component: Contacts,
      children: [
        {
          path: ':contactID',
          name: 'admin.nylas.contact.show',
          components: ContactCard
        }
      ]
    },
    {
      path: '/v2/admin/folders',
      name: 'folders',
      component: Folders,
      meta: {
        permission: 'can_edit_folders',
      },
    },
    {
      path: '/v2/admin/presentations',
      name: 'presentations',
      component: Presentations,
      meta: {
        permission: 'can_edit_presentations',
      },
    },
    {
      path: '/v2/admin/presentations/upload',
      name: 'presentations.upload',
      component: UploadPresentations,
      meta: {
        permission: 'can_edit_presentations',
      },
    },
    {
      path: '/v2/admin/presentations/:presentationID(\\d+)',
      component: Presentation,
      children: [
        { // MLD-6435
          path: 'slides',
          name: 'admin.presentation.slides',
          component: AdminSlides,
          meta: {
            permission: 'can_edit_presentations',
          },
        },
        { // MLD-6435
          path: 'custom-presentations',
          name: 'admin.presentation.slide_decks',
          component: AdminSlideDecks,
          meta: {
            permission: 'can_edit_presentations',
          },
        },
        {
          path: '',
          name: 'presentation.show',
          component: ShowPresentation,
          meta: {
            //permission: 'can_edit_presentations',
          },
        },
        { // MLD-3875
          path: 'sharing-sessions',
          name: 'admin.sharing_sessions.index',
          component: AdminSharingSessions,
          meta: {
            //permission: 'can_edit_presentations',
          },
        },
        { // MLD-3875
          path: 'sharing-sessions/:sessionID(\\d+)',
          name: 'admin.sharing_session.show',
          component: AdminShowSharingSession,
          meta: {
            //permission: 'can_edit_presentations',
          },
        },
        {
          path: 'info',
          name: 'presentation.info',
          component: PresentationInfo,
          meta: {
            //permission: 'can_edit_presentations',
          },
        },
        {
          path: 'edit',
          name: 'presentation.edit',
          component: EditPresentation,
          meta: {
            permission: 'can_edit_presentations',
          },
        },
        {
          path: 'upload',
          name: 'presentation.upload',
          component: UploadPresentation,
          meta: {
            permission: 'can_edit_presentations',
          },
        },
      ]
    },
    { // MLD-3306
      path: '/v2/admin/products',
      name: 'admin.products',
      component: Products,
      meta: {
        permission: 'can_edit_products',
      },
    },
    { // MLD-4360
      path: '/v2/admin/products/create',
      name: 'admin.product.create',
      component: CreateProduct,
      meta: {
        permission: 'can_edit_products',
      },
    },
    { // MLD-4360
      path: '/v2/admin/products/:productID(\\d+)',
      name: 'admin.product.show',
      component: ShowProduct,
      meta: {
        permission: 'can_edit_products',
      },
    },
    { // MLD-4360
      path: '/v2/admin/products/:productID(\\d+)/edit',
      name: 'admin.product.edit',
      component: EditProduct,
      meta: {
        permission: 'can_edit_products',
      },
    },
    {
      path: '/v2/admin/team/dashboard',
      name: 'team.dashboard',
      component: TeamDashboard,
      meta: {
        permission: 'can_edit_team',
      },
    },
    { // MLD-5581
      path: '/v2/admin/users/administrators',
      component: AdministratorPermissionGrid,
      name: 'admin.administrators',
      meta: {
        permission: 'can_edit_users',
      },
    },
    {
      path: '/v2/admin/users/:userID(\\d+)',
      component: User,
      children: [
        {
          path: '',
          name: 'admin.user.show',
          component: ShowUser,
          meta: {
            permission: 'can_edit_users',
          },
        },
        {
          path: 'connections',
          name: 'admin.user.connections',
          component: UserConnections,
          meta: {
            permission: 'can_edit_users',
          },
        },
        {
          path: 'edit',
          name: 'admin.user.edit',
          component: EditUser,
          meta: {
            permission: 'can_edit_users',
          },
        },
        {
          path: 'teams',
          name: 'admin.user.teams',
          component: UserTeams,
          meta: {
            permission: 'can_edit_users',
          },
        },

      ]
    },
    { // MLD-2453
      path: '/v2/admin/blocked-recipients',
      name: 'blocked_recipients',
      component: BlockedRecipients,
      meta: {
        permission: 'can_edit_subscribers',
      },
    },
    { // MLD-5628
      path: '/v2/admin/files',
      name: 'admin.team_assets.index',
      component: AdminTeamAssets,
      meta: {
        permission: 'can_edit_files',
      },
    },
    {
      path: '/v2/admin/groups',
      name: 'admin.groups.index',
      component: Groups,
      meta: {
        permission: 'can_edit_groups',
      },
    },
    {
      path: '/v2/admin/groups/:groupID(\\d+)',
      component: Group,
      children: [
        {
          path: '',
          name: 'admin.group.show',
          component: ShowGroup,
        },
        {
          path: 'edit',
          name: 'admin.group.edit',
          component: EditGroup,
          meta: {
            permission: 'can_edit_groups',
          },
        },
      ]
    },
    {
      path: '/v2/admin/groups/create',
      name: 'admin.group.create',
      component: CreateGroup,
      meta: {
        permission: 'can_edit_groups',
      },
    },
    { // MLD-5194
      path: '/v2/admin/groups/membership-grid',
      name: 'admin.groups.membership_grid',
      component: GroupMembershipGrid,
      meta: {
        permission: 'can_edit_groups',
      },
    },
    { // MLD-5194
      path: '/v2/admin/groups/presentation-access-grid',
      name: 'admin.groups.presentation_access_grid',
      component: PresentationGrid,
      meta: {
        permission: 'can_edit_groups',
      },
    },
    { // MLD-5194
      path: '/v2/admin/groups/email-template-access-grid',
      name: 'admin.groups.share_template_access_grid',
      component: ShareTemplateGrid,
      meta: {
        permission: 'can_edit_groups',
      },
    },
    { // MLD-5627
      path: '/v2/admin/shared-links',
      name: 'admin.shared_links.index',
      component: AdminSharedLinks,
      meta: {
        permission: 'can_edit_presentations',
      },
    },
    { // MLD-5627
      path: '/v2/admin/shared-links/:linkID(\\d+)',
      component: SharedLink,
      children: [
        {
          path: 'edit',
          component: EditSharedLink,
          name: 'admin.shared_link.edit',
          meta: {
            permission: 'can_edit_presentations',
          },
        }
      ]
    },
    {
      path: '/v2/admin/settings/subscription',
      name: 'subscription',
      component: Subscription,
      meta: {
        permission: 'can_edit_team',
      },
    },
    {
      path: '/v2/admin/settings/subscription/change/review',
      name: 'change_subscription.review',
      component: ChangeSubscriptionReview,
      meta: {
        permission: 'can_edit_team',
      },
    },
    {
      path: '/v2/admin/settings/subscription/details',
      name: 'billing_details.edit',
      component: EditBillingDetails,
      meta: {
        permission: 'can_edit_team',
      },
    },
    { // MLD-6326
      path: '/v2/admin/subscribers',
      name: 'admin.subscribers.index',
      component: Subscribers,
      meta: {
        permission: 'can_edit_subscribers',
      }
    },
    {
      path: '/v2/admin/team/edit',
      name: 'team.edit',
      component: EditTeam,
      meta: {
        permission: 'can_edit_team',
      },
    },
    { // MLD-6465
      path: '/v2/admin/teams',
      name: 'admin.teams.index',
      component: AdminTeams,
      meta: {
        title: 'Teams',
      },
    },
    { // MLD-5472
      path: '/v2/admin/territories',
      name: 'admin.territories.index',
      component: Territories,
      meta: {
        permission: 'can_edit_territories',
      },
    },
    {
      path: '/v2/admin/territories/:territoryID(\\d+)',
      component: Territory,
      children: [
        {
          path: '',
          name: 'admin.territory.show',
          component: ShowTerritory,
          meta: {
            permission: 'can_edit_territories',
          },
        },
        {
          path: 'edit',
          name: 'admin.territory.edit',
          component: EditTerritory,
          meta: {
            permission: 'can_edit_territories',
          },
        },
      ],
    },
    {
      path: '/v2/admin/users',
      name: 'users',
      component: Users,
      meta: {
        permission: 'can_edit_users',
      },
    },
    {
      path: '/v2/admin/users/create',
      name: 'user.create',
      component: CreateUser,
      meta: {
        permission: 'can_edit_users',
      },
    },
    {
      path: '/v2/admin/user-contacts',
      name: 'admin.user_contacts.index',
      component: AdminUserContacts,
      meta: {
        permission: 'can_edit_user_contacts',
      },
    },
    {
      path: '/v2/admin/user-contacts/upload',
      name: 'admin.user_contacts.upload',
      component: AdminUploadUserContacts,
      meta: {
        permission: 'can_edit_user_contacts',
      },
    },
    ...DisclaimerAdminRoutes,
    ...LabelAdminRoutes,
    ...MailcoachAdminRoutes,
    ...MailgunAdminRoutes,
    ...PepperFlowRoutes, // MLD-5650
    ...ShareTemplatesAdminRoutes,
    ...TeamDomainAdminRoutes,
    ...VaultRoutes,
  ]),
]
